export default __webpack_public_path__ + "static/sunsoaked-1c7e441d808fa4af88d401f7c94accd9.webp";